import { memo, useCallback } from 'react';
import { makeFloat, useCurrency, useGetFullBalance, useUpdateBonusStatus } from 'react-easyrocket';
import { useTranslation } from 'react-i18next';
import { Button } from 'src/components/Buttons/Button';
import { useModalContext } from 'src/hooks/useModalContext';
import { ModalWrapper } from '../components/ModalWrapper';

export const ConfirmBonusModal = memo(function ConfirmBonusModal() {
  const { modalProps, closeModal } = useModalContext<{
    onCancel?: () => void;
    bonusId: number;
  }>();
  const { mutateAsync: updateBonusStatus, isPending } = useUpdateBonusStatus();
  const { t } = useTranslation();
  const { bonusAccountCasino } = useGetFullBalance();
  const { currencyIcon } = useCurrency();

  const handleOkay = useCallback(async () => {
    await updateBonusStatus({ bonus_id: modalProps?.bonusId, status: 'Activated' });
    closeModal();
  }, [closeModal, modalProps?.bonusId, updateBonusStatus]);

  const handleCancel = useCallback(() => {
    if (modalProps?.onCancel) {
      modalProps?.onCancel?.();
    } else {
      closeModal();
    }
  }, [closeModal, modalProps]);

  return (
    <ModalWrapper
      showCross={false}
      className="640:!max-w-[500px] !max-w-full w-full"
      containerClassName="640:pb-7 p-5 pb-[38px] !rounded-b-none 640:!rounded-b-[20px] mt-auto 640:mt-0 flex flex-col items-center bg-cbm_bg rounded-2xl 640:border-solid border-[1px] border-none">
      <p className="mb-2 text-cbm_title text-lg leading-[24px] font-bold uppercase text-center">
        {t('bonusModal.areYouSure')}
      </p>

      <div className="w-full text-center">
        <p className="text-cbm_text font-medium text-base mb-0.5">
          {t('bonusModal.whenYouChange')}
        </p>
        <p className="text-cbm_value text-xl leading-8 font-medium">
          {currencyIcon + makeFloat(bonusAccountCasino?.balance)}
        </p>
      </div>

      <div className="w-full flex flex-col 640:flex-row gap-1 mt-2.5">
        <Button
          label={t('bonusModal.yesSure')}
          title={t('bonusModal.yesSure')}
          onClick={handleOkay}
          loading={isPending}
          className="!max-w-full"
        />
        <Button
          label={t('general.cancel')}
          title={t('general.cancel')}
          className="!max-w-full"
          mode="button-base"
          onClick={handleCancel}
        />
      </div>
    </ModalWrapper>
  );
});
